export const tenantDefaults = {
    tradeName: "", // Nome fantasia
    corporateName: "", // Razão social
    document: "", // CNPJ
    email: "",
    phone: "",
    website: "",

    logoUrl: null,
    brandColor: "#3b82f6",

    // Endereço (flat form)
    zipCode: "",
    address: "",
    number: "",
    complement: "",
    neighborhood: "",
    city: "",
    state: "",
    country: "Brasil",

    // Representante Legal
    legalRepresentative: {
        name: "",
        cpf: "",
        email: "",
        phone: ""
    }
};
